import { useNavigate } from "react-router-dom";
import { Timestamp } from "firebase/firestore";
import { isMatchCompleted } from "utils/match";
import { MatchTypes } from "enums/matchType";
import QRIcon from "assets/QRIcon.svg";
import PropTypes from "prop-types";
import { useState } from "react";
import "./styles.css";

import HeaderIndicator from "./sub/HeaderIndicator";
import { Description } from "./matchDescriptions";
import HeaderTitle from "./sub/HeaderTitle";

function Header({
  event,
  userData,
  showTitle,
  showPayout,
  usersArray,
  hideQr,
  goBack,
}) {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const navigate = useNavigate();

  const {
    date,
    stake,
    title,
    bets,
    matchType,
    secondPlace,
    firstPlace,
    scoreToWin,
    carryOver,
    wagerType,
    ballCount,
    maxScore,
  } = event ?? {};
  const { matchType: secondBetMatchType, stake: secondBetStake } =
    bets?.[0] ?? 1;

  const isOn = !isMatchCompleted(event ?? {});

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  const payoutList = usersArray
    ?.sort((a, b) => b.net - a.net)
    .map((i) => i.net);

  return (
    <header className="header">
      <div
        className="header-container"
        // onClick={() => {
        //   if (!!userData && !Number.isNaN(Number(userData.handicap))) {
        //     toggleDropdown();
        //   }
        // }}
        aria-hidden
      >
        <div
          aria-hidden="true"
          style={{ backgroundColor: "transparent" }}
          onClick={() =>
            goBack ? navigate(-1) : navigate("/", { replace: true })
          }
        >
          <img
            className="common-header--logo"
            src="https://kecamps.com/_media/camp_logos/mobile_logo.png"
            alt="CCM Logo"
          />
        </div>

        <HeaderTitle
          date={date}
          matchTypeName={MatchTypes[matchType]}
          title={showTitle && title}
          bets={bets?.[0]}
        />

        {event && <HeaderIndicator live={isOn} />}

        {!hideQr && (
          <div
            style={{
              height: 40,
              width: 40,
              display: "grid",
              placeItems: "center",
              border: "1.5px solid #8E9191",
              borderRadius: 8,
              marginLeft: 8,
            }}
            aria-hidden
            onClick={() => navigate("share", { relative: false })}
          >
            <img src={QRIcon} alt="share button" />
          </div>
        )}
      </div>
      {/* {!!userData && !Number.isNaN(Number(userData.handicap)) && (
        <div
          className="header--handle-bar"
          style={{ opacity: isDropdownVisible && 0 }}
        />
      )} */}

      <div
        className={`dropdown-menu ${isDropdownVisible ? "visible" : "hidden"}`}
      >
        <Description
          quota={!!userData && userData?.handicap}
          secondPlace={secondPlace}
          firstPlace={firstPlace}
          matchType={matchType}
          stake={stake}
          secondBetMatchType={secondBetMatchType}
          scoreToWin={scoreToWin}
          carryOver={carryOver}
          wagerType={wagerType}
          showPayout={showPayout}
          payoutList={payoutList}
          secondBetStake={secondBetStake}
          onDescriptionClick={toggleDropdown}
          ballCount={ballCount}
          maxScore={maxScore}
        />

        {/* <div
          onClick={() => {
            if (!!userData && !Number.isNaN(Number(userData.handicap))) {
              toggleDropdown();
            }
          }}
          className="header--handle-bar"
          style={{ opacity: !isDropdownVisible && 0 }}
          aria-hidden
        /> */}
      </div>
      {/* {userData && !userData?.uid && (
        <div
          style={{
            backgroundColor: "#ff375f",
            width: "100%",
            padding: 10,
            borderBottomLeftRadius: 10,
            borderBottomRightRadius: 10,
            boxShadow: "0px 12.6667px 50.6667px rgba(0, 0, 0, 0.25)",
          }}
          onClick={() => navigation(`/event/${eventId}/hdcp`)}
        >
          <Text as="P2">Your handicap is autdated! Tap here for update</Text>
        </div>
      )} */}
      {/* {userData && !userData.venmo && (
        <div
          style={{
            backgroundColor: "#ff375f",
            width: "100%",
            padding: 10,
            borderBottomLeftRadius: 10,
            borderBottomRightRadius: 10,
            boxShadow: "0px 12.6667px 50.6667px rgba(0, 0, 0, 0.25)",
            zIndex: 9,
          }}
        >
          <Text as="P2">
            Sorry, couldn&apos;t find your Venmo username. Hit to add it. 👉
          </Text>
        </div>
      )} */}
    </header>
  );
}

export { Header };

Header.propTypes = {
  event: PropTypes.shape({
    date: PropTypes.instanceOf(Timestamp),
    stake: PropTypes.number,
    matchType: PropTypes.number,
    wagerType: PropTypes.number,
    slope: PropTypes.number,
    rating: PropTypes.number,
    par: PropTypes.number,
    teeTimesValid: PropTypes.arrayOf(PropTypes.string),
    teeTimesSubmitted: PropTypes.arrayOf(PropTypes.string),
  }),
  userData: PropTypes.shape({
    handicap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    uid: PropTypes.string,
    venmo: PropTypes.string,
  }),

  showTitle: PropTypes.bool,
  showPayout: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  usersArray: PropTypes.arrayOf(PropTypes.any),
  hideQr: PropTypes.bool,
  goBack: PropTypes.bool,
};

Header.defaultProps = {
  event: undefined,
  userData: {
    venmo: null,
  },
  showTitle: false,
  showPayout: false,
  usersArray: [],
  hideQr: false,
  goBack: false,
};
